import { LoginURLState } from 'web-shared/services/sso-auth-service/SSOService';

export const parseLoginState = (state?: string): LoginURLState | null => {
  if (!state) return null;

  try {
    return JSON.parse(state);
  } catch {
    return null;
  }
};
